import React from 'react';
import { Box, Tooltip, useMediaQuery } from '@mui/material';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';

const CustomTabs = ({
  tabs = [],
  activeTab,
  onTabChange,
  tabLabels = {},
  enabledTabs = tabs, 
  arrow = false,
  disabledReasons={}
}) => {
  const isMobile = useMediaQuery('(max-width:600px)');

  const handleTabChange = (tab) => {
    if (enabledTabs.includes(tab)) {
      onTabChange(tab);
    }
  };

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      borderBottom: '1px solid #e0e0e0',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    }}>
      {tabs.map((tab, index) => {
        const isEnabled = enabledTabs.includes(tab);
        const label = tabLabels[tab] || tab;
        const disabledTooltip = disabledReasons[tab] || '';

        const tabBox = (
          <Box
            onClick={() => {
              if (isEnabled) onTabChange(tab);
            }}
            sx={{
              padding: '12px 16px',
              cursor: isEnabled ? 'pointer' : 'not-allowed',
              borderBottom:
                activeTab === tab
                  ? '3px solid #F14950'
                  : '2px solid transparent',
              color: !isEnabled
                ? '#ccc'
                : activeTab === tab
                  ? '#F14950'
                  : '#8C8C8C',
              fontWeight: 500,
              fontSize: '16px',
              transition: 'all 0.3s ease',
              pointerEvents: isEnabled ? 'auto' : 'none',
              '&:hover': {
                color: isEnabled ? '#F14950' : '#ccc',
              },
            }}
          >
            {label}
          </Box>
        );

        return (
          <React.Fragment key={tab}>
            {isEnabled ? (
              tabBox
            ) : (
              <Tooltip title={disabledTooltip} arrow>
                <Box>{tabBox}</Box>
              </Tooltip>
            )}

            {arrow && !isMobile && index < tabs.length - 1 && (
              <ArrowForwardOutlinedIcon sx={{ fontSize: 18, color: '#F14950' }} />
            )}
          </React.Fragment>
        );
      })}
    </Box>
  );
};

export default CustomTabs;